import { RequestContext } from '@fiverr-private/perseus';
import { isActive } from '@fiverr-private/rollout_js';
import { EXPERIMENT_TYPE } from '@fiverr-private/experiments';
import { EXPERIMENTS, ROLLOUTS } from '@fiverr-private/listing_experiments';

const inRollout = async () => {
    const { userId, userGuid } = RequestContext;
    const identifier = userId || userGuid;
    return identifier ? await isActive(ROLLOUTS.COBRAS_HOURLY_FILTER_EXPOSURE, identifier) : false;
};

const shouldAllocate = () => {
    const {
        experience: { isBusiness },
    } = RequestContext;
    // Only allocate non-business users in MP
    return !isBusiness;
};

export const hourlyToggleFilter = {
    id: EXPERIMENTS.COBRAS_HOURLY_FILTER_EXPOSURE,
    experimentType: EXPERIMENT_TYPE.USER,
    numOfGroups: 3,
    shouldAllocate,
    inRollout,
};
